import type { CSSProperties, ReactNode } from "react";

export interface PageContainerProps {
  children: ReactNode;
  /**
   * Begrenzt die Lesebreite (z. B. für Settings-/Formular-lastige Seiten).
   * Default: keine Begrenzung (volle Content-Breite).
   */
  maxWidth?: number | string;
  /** Abstand zwischen Abschnitten. Standard: `--mq-page-gap` (gemeinsame Grundkarte, 16 px). */
  gap?: number | string;
  className?: string;
  style?: CSSProperties;
}

/**
 * Strukturcontainer für mQorva-Frontends. Seiten mit Standardkopf verwenden PageFrame.
 *
 * Ersetzt das verbreitete Muster, jeder Section/Card einzeln `marginBottom` zu geben:
 * `<PageContainer>` ist ein Flex-Column-Wrapper mit konsistentem vertikalem Gap.
 * Abstände aus den gemeinsamen Maßen `--mq-*` (`shared/frontend/ui/tokens.css`).
 *
 * @example
 * ```tsx
 * <PageContainer>
 *   <SectionCard title={tr("Overview")}>…</SectionCard>
 *   <SectionCard title={tr("Details")}>…</SectionCard>
 * </PageContainer>
 * ```
 */
export function PageContainer({ children, maxWidth, gap, className, style }: PageContainerProps) {
  return (
    <div
      className={className ? `mq-page ${className}` : "mq-page"}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: gap ?? "var(--mq-page-gap, 16px)",
        minWidth: 0,
        ...(maxWidth != null ? { maxWidth, width: "100%" } : null),
        ...style,
      }}
    >
      {children}
    </div>
  );
}
